import { Spinner } from '@components/common/Spinner'
import { theme } from '../../theme'

export default function Loader() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: theme.spacing.sm
    }}>
      <Spinner
        size="large"
        style={{ color: theme.colors.primary }}
      />
      <div style={{
        color: theme.colors.text.secondary,
        fontSize: theme.typography.body.fontSize,
        marginTop: theme.spacing.sm
      }}>
        Loading...
      </div>
    </div>
  )
}